'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var productDetailComponent = exports.productDetailComponent = {
    template: require('./detail.html'),
    bindings: {
        product: '<',
        parentState: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "$state", "common", "newsService", "Analytics", "productService", "StockOverview", "cartService", "gettextCatalog", "exceptionService", "$timeout", "$window", "ProductTypes", "authService", "$stateParams", "certificatesService", function controller($scope, $state, common, newsService, Analytics, productService, StockOverview, cartService, gettextCatalog, exceptionService, $timeout, $window, ProductTypes, authService, $stateParams, certificatesService) {
        'ngInject';

        var vm = this;
        vm.newsitems = null;
        vm.topNewsitems = null;
        vm.shortNewsitems = null;
        vm.medipimDataLoading = false;
        vm.isEmptyObject = isEmptyObject;
        vm.$onInit = init;
        vm.updateTotals = updateTotals;
        vm.checkStock = checkStock;
        vm.addToCart = addToCart;
        vm.isFebelcoCustomer = isFebelcoCustomer;
        vm.loadMedipimData = loadMedipimData;
        vm.loadIcoreData = loadIcoreData;
        $scope.forms = {};

        function init() {

            common.setTitle(vm.product.displayName);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/products/' + vm.product.id, vm.product.displayName);
            if (vm.product.type === 'single') {
                loadMedipimData();
            }
            loadIcoreData();
            //update quantity on enter
            if (authService.isBuyer) {
                angular.element($window).on('keydown', function (event) {
                    if (event.which === 13 && vm.addingProducts !== true && vm.productsQuantityChanged) {
                        vm.addToCart();
                    }
                });

                $scope.$on('$destroy', function () {
                    angular.element($window).off('keydown');
                });
            }

            vm.topNewsitems = vm.product.topNewsitems;

            vm.mainImage = vm.product.image;

            Analytics.addProduct(vm.product.id, vm.product.displayName, vm.product.type, vm.product.brand, '', vm.product.price, vm.product.quantity, '', '', {
                sellerId: vm.product.sellerId,
                sellerName: vm.product.sellerName,
                discountId: vm.product.discountId
            });

            Analytics.trackDetail();
        }

        function isEmptyObject(o) {
            if (o) {
                return Object.keys(o).every(function (x) {
                    return o[x] === '' || o[x] === null || o[x] === false || o[x] === 0 || o[x] === undefined;
                });
            } else {
                return true;
            }
        }

        function loadMedipimData() {
            vm.medipimDataLoading = true;
            productService.getProductMedipimdata($stateParams.productId).then(function (medipimData) {
                vm.medipimDataLoading = false;
                vm.product.mediPimData = medipimData;
            });
        }

        function loadIcoreData() {
            var search = {
                identification: vm.product.nationalNumber,
                isExpired: false
            };
            certificatesService.searchCertificates(search).then(function (response) {
                vm.product.certificates = response.results;
            });
        }

        function updateTotals() {
            vm.isOpen = true;
            vm.productsAdded = false;
            vm.productsQuantityChanged = true;
            if (vm.product.type === ProductTypes.panacee.clientValue) {
                vm.product.updateTotals();
            }
        }

        function checkStock() {
            vm.stockOverview = StockOverview.create();
            vm.stockOverview.isLoading = true;
            var quantity = vm.product.quantity === 0 ? 1 : vm.product.quantity;
            productService.getProductStock(vm.stockOverview, vm.product.nationalNumber, quantity).then(function (model) {
                vm.stockOverview.hasloaded = true;
                vm.stockOverview.isLoading = false;
                vm.stockOverview = model;
            });
        }

        function addToCart() {

            vm.productsQuantityChanged = false;
            vm.addingProducts = true;
            vm.hasError = false;

            cartService.addProduct(vm.product).then(function (shoppingCartProducts) {

                if ($scope.forms.productOverviewForm) {
                    $scope.forms.productOverviewForm.$setPristine();
                }

                //update the discount values after add
                vm.product = vm.product.getCartFields(vm.product, shoppingCartProducts);
                vm.productsAdded = true;
                vm.addToCartEnabled = true;
                vm.addingProducts = false;

                $timeout(function () {
                    vm.isOpen = false;
                }, 5000);
            }).catch(function () {

                vm.addToCartEnabled = false;
                vm.addingProducts = false;
                vm.hasError = true;

                var msg = gettextCatalog.getString('The product could not be added to your shopping cart');
                exceptionService.logException(msg);

                $timeout(function () {
                    vm.hasError = false;
                    vm.isOpen = false;
                }, 5000);
            });
        }

        function isFebelcoCustomer() {
            return authService.isFebelcoCustomer;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/product/detail.js
// module id = 984
// module chunks = 0